import React, { useState } from 'react';
import './DataVerification.css';

function DataVerification() {
  const [selectedCompany, setSelectedCompany] = useState('전체');
  const [selectedDateRange, setSelectedDateRange] = useState('7일');
  const [searchQuery, setSearchQuery] = useState('');

  const dataLogs = [
    {
      id: 1,
      timestamp: '2024-02-01 14:32:15',
      company: '삼성전자',
      factory: 'A공장',
      machine: '1사출 05호기',
      dataType: '생산량',
      value: '1,245',
      unit: 'EA',
      status: '정상',
      operator: '김작업'
    },
    {
      id: 2,
      timestamp: '2024-02-01 14:30:42',
      company: 'LG전자',
      factory: 'B공장',
      machine: '2사출 03호기',
      dataType: '에너지 사용량',
      value: '125.5',
      unit: 'kWh',
      status: '정상',
      operator: '이운영'
    },
    {
      id: 3,
      timestamp: '2024-02-01 14:28:20',
      company: '삼성전자',
      factory: 'A공장',
      machine: '1사출 02호기',
      dataType: '온도',
      value: '285',
      unit: '°C',
      status: '경고',
      operator: '박관리'
    },
    {
      id: 4,
      timestamp: '2024-02-01 14:25:10',
      company: '현대자동차',
      factory: 'C공장',
      machine: '3사출 01호기',
      dataType: '사이클 타임',
      value: '45.2',
      unit: '초',
      status: '정상',
      operator: '최현장'
    },
    {
      id: 5,
      timestamp: '2024-02-01 14:20:05',
      company: 'LG전자',
      factory: 'B공장',
      machine: '2사출 05호기',
      dataType: '압력',
      value: '1,850',
      unit: 'bar',
      status: '오류',
      operator: '정기술'
    },
    {
      id: 6,
      timestamp: '2024-02-01 14:15:30',
      company: '삼성전자',
      factory: 'A공장',
      machine: '1사출 03호기',
      dataType: '생산량',
      value: '980',
      unit: 'EA',
      status: '정상',
      operator: '김작업'
    }
  ];

  const getStatusClass = (status) => {
    switch (status) {
      case '정상':
        return 'status-normal';
      case '경고':
        return 'status-warning';
      case '오류':
        return 'status-error';
      default:
        return '';
    }
  };

  const getStatusIcon = (status) => {
    switch (status) {
      case '정상':
        return 'check_circle';
      case '경고':
        return 'warning';
      case '오류':
        return 'error';
      default:
        return 'info';
    }
  };

  const filteredLogs = dataLogs.filter(log => {
    const matchesCompany = selectedCompany === '전체' || log.company === selectedCompany;
    const matchesSearch =
      log.machine.toLowerCase().includes(searchQuery.toLowerCase()) ||
      log.dataType.toLowerCase().includes(searchQuery.toLowerCase()) ||
      log.factory.toLowerCase().includes(searchQuery.toLowerCase());
    return matchesCompany && matchesSearch;
  });

  const stats = {
    totalRecords: dataLogs.length,
    normalCount: dataLogs.filter(log => log.status === '정상').length,
    warningCount: dataLogs.filter(log => log.status === '경고').length,
    errorCount: dataLogs.filter(log => log.status === '오류').length
  };

  return (
    <div className="data-verification-container">
      <p>개발 예정</p>
    </div>
  );
}

export default DataVerification;
